
import { t } from "i18next";


export class SurveyQuestionType {

    static TEXT = new SurveyQuestionType(0, t('main.report_text'), t('main.report_text_description'));
    static RATING = new SurveyQuestionType(1, t('main.report_rating'), t('main.report_rating_description'));
    static COMMENT = new SurveyQuestionType(2, t('main.report_yesNo'), t('main.report_yesNo_description'));
    static DROPDOWN = new SurveyQuestionType(3, t('main.report_dropdown'), t('main.report_dropdown_description'));
    static MULTIPLE_CHOICE = new SurveyQuestionType(4, t('main.report_multipleChoice'), t('main.report_multipleChoice_description'));
    static DATE = new SurveyQuestionType(5, t('main.report_date'), t('main.report_date_description'));
    static ALL_TYPES = [SurveyQuestionType.TEXT, SurveyQuestionType.RATING, SurveyQuestionType.COMMENT, SurveyQuestionType.DROPDOWN, SurveyQuestionType.MULTIPLE_CHOICE, SurveyQuestionType.DATE];

    public key: number;
    public name: string;
    public description: string;

    constructor(key: number, name: string, description: string) {
        this.key = key;
        this.name = name;
        this.description = description;
    }

    static getType(id: number): SurveyQuestionType {
        for (let type of this.ALL_TYPES) {
            if ("" + type.key === "" + id) {
                return type;
            }
        }
        return SurveyQuestionType.TEXT
    }
}